import { BackendResponse } from "../BackendResponse";
import { FormDataWithKeyCheck } from "../FormDataFactory";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { Answers } from "../questionForm/QuestionFormTypes";

export interface ApplyWithProfileResponse extends BackendResponse {
  idCandidate: number;
  typeRelated: number;
  idRelated: number;
  idRecruitmentCandidate: number | null;
  idVacancyCandidate: number | null;
  idStatus: number;
  statusCaption: string;
}

export interface ApplyWithProfileParameters extends NextApiParams {
  formData: FormDataWithKeyCheck<CvpApplyWithProfileMultiAttachmentsParameters>;
}

export const applyWithProfileMultiAttachements = withNextApi<
  ApplyWithProfileResponse,
  ApplyWithProfileParameters
>("/cvp/CvpApplyWithProfileMultiAttachements");

export interface CvpApplyWithProfileMultiAttachmentsParameters {
  typeRelated: number;
  idRelated: number;
  publicApplicantListIsOkay: boolean;
  triggerSystemEvent: boolean;
  attachFileToCaseCandidateInsteadOfCandidate: boolean;
  attachments: any[];
  applicationText: string;
  questionFormAnswers: Answers[];
  cvpExtraApplicationFieldValues: { [key: string]: string };
}
